import {Component, Inject, AfterViewInit, signal, WritableSignal, ViewChild, OnDestroy} from '@angular/core';
import { Router } from '@angular/router';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';

import { AppService } from 'src/app/app.service';
import { DialogsService } from 'src/app/_services/dialogs.service';
import { OrderService } from 'src/app/_services/order.service';
import { OrderItemsUtilsService } from 'src/app/order-items/order-items-util.service';
import { OrderItemsDialogsService } from 'src/app/order-items/order-items-dialogs.service';
import { TabitOrderProcessService } from 'src/app/tabit-order/tabit-order-process.service';

import * as _ from 'lodash';
import {ChatService} from "../../chat-bot/chat.service";
import {animate, query, stagger, style, transition, trigger} from "@angular/animations";
import {LottieAnimationComponent} from "../../components/lottie-animation/lottie-animation.component";

@Component({
    selector: 'app-tabit-order-summary',
    templateUrl: './tabit-order-summary.component.html',
    styleUrl: './tabit-order-summary.component.scss',
	animations: [
		trigger('listAnimation', [
			transition('* => *', [ // Any state change
				query(':enter', [ // Query for elements entering the DOM
					style({ opacity: 0, transform: 'translateY(-20px)' }),
					stagger(100, [ // Stagger the animations by 100ms
						animate('0.3s ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
					])
				], { optional: true }),
				query(':leave', [ // Query for elements leaving the DOM
					stagger(100, [
						animate('0.3s ease-in', style({ opacity: 0, transform: 'translateY(-20px)' }))
					])
				], { optional: true })
			])
		])
	],
    standalone: false
})
export class TabitOrderSummaryComponent implements AfterViewInit, OnDestroy {
	$storage;
	basket;
	maxHeight = '310px'
	aiLoading = signal(false);
	workMode = signal('basket');
	wasUpsell = signal(false);
	aiMessages:WritableSignal<any> = signal([]);

	constructor(
		private _bottomSheetRef: MatBottomSheetRef<TabitOrderSummaryComponent>,
		@Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
		public appService: AppService,
		public dialogsService: DialogsService,
		public chatService: ChatService,
		public orderService: OrderService,
		public orderUtils: OrderItemsUtilsService,
		public orderDialogs: OrderItemsDialogsService,
	) {
		this.$storage = this.orderService.$storage;
		this.basket = this.$storage.basket;
		this.orderService.checkBasketAlcohol(this.$storage);
	}

	ngOnDestroy(): void {
		this.chatService.abortMessageStream();
	}

	ngAfterViewInit() {
		let offHeight = 310;
		try {
			offHeight = document.getElementById('items-summary-bottom').offsetHeight;
		}catch (e) {}
		this.maxHeight = `${window.innerHeight - (offHeight + 70)}px`
	}

	editOffer(offer) {
		this.orderDialogs.openOfferDialog(offer, true).then((result: any) => {
			if (result) {
				if (result.mode === 'delete') {
					this.deleteOfferCont(offer);
				}else {
					let index = this.basket.indexOf(offer);
					this.basket[index] = result["viewItem"];
					this.onChange();
				}
			}
		});
	}

	deleteOffer(offer, deleteAll?) {
		if (offer.quantity > 1 && !deleteAll && !offer._reserved?.benefitId && !offer.isLoyaltyOffer) {
			//this.loyaltyService.removeSingleBenfitFromOffer(this.$storage, offer);
			--offer.quantity;
			this.onChange();
			return;
		}
		let args: any;
		if (offer._reserved?.benefitId) {
			args = {
				"content": this.appService.translate("_LOYALTY.confirmDeleteOffer_reserved"),
				showCancelButton: true,
				confirmText: this.appService.translate("_LOYALTY_REG.removeOfferButton"),
				cancelText: this.appService.translate("_LOYALTY_REG.keepOfferButton")
			}
		}
		else if (offer.isLoyaltyOffer) {
			args = {
				"content": this.appService.translate("_LOYALTY_REG.confirmDeleteOffer"),
				showCancelButton: true,
				confirmText: this.appService.translate("_LOYALTY_REG.removeOfferButton"),
				cancelText: this.appService.translate("_LOYALTY_REG.keepOfferButton")
			}
		} else {
			args = {
				"content": this.appService.translate("TO.q_remove_offer_from_basket"),
				showCancelButton: true,
				confirmText: this.appService.translate("remove")
			}
		}
		this.appService.confirm(args).then(() => {
			if (offer._reserved) {
				if (offer._reserved?.benefitId) {
					//this.loyaltyService.cancelBenefitFromOffer(this.$storage, offer._reserved?.benefitId);
				}
			}
			this.deleteOfferCont(offer);
		});
	}
	deleteOfferCont(offer) {
		let index = this.basket.indexOf(offer);
		this.$storage.basket.splice(index, 1);
		//this.loyaltyService.getSelectedManualBenfitsCount(this.$storage);
		this.onChange(offer.isLoyaltyOffer ? 'deleteLoyaltyOffer' : 'deleteOffer');
	}

	duplicateOffer(offer) {
		this.orderService.validateOrderLimit(1, offer.total).then(() => {
			if (offer._reserved) {
				let newOffer = _.cloneDeep(offer);
				delete newOffer._reserved;
				newOffer._bid = this.orderUtils.getObjectId();
				newOffer.quantity = 1;
				this.$storage.basket.push(newOffer);
			} else {
				++offer.quantity;
			}
			this.onChange();
		});
	}

	onChange(args?) {
		this.orderService.cacheOrder();
		this.orderService.calculateBasketTotal();
		if (!this.$storage.basket.length) {
			this._bottomSheetRef.dismiss();
		}else{
			this.orderService.checkBasketAlcohol(this.$storage);
		}
	}

	backToMenu() {
		this._bottomSheetRef.dismiss('menu');
	}


	wasUpsellResponse: boolean = false;
	async aiContinue() {
		this.wasUpsell.set(true);
		this.aiLoading.set(true);
		this.workMode.set('upsell');
		try {
			let response: any = await this.chatService.getBotUpsell(this.aiMessages);
			this.aiLoading.set(false);
			if (response) {
				return;
			}
		} catch (e) {

		}
	}

	async continue() {
		if (this.data.isInCheckout) {
			this.cancel();
		} else {
			if (this.workMode() === 'upsell') {
				this.workMode.set('basket');
			} else {
				this.aiLoading.set(false);
				this._bottomSheetRef.dismiss('next');
			}
		}
	}
	aiOfferClick(o, ev) {
		const result = this.chatService.processSystemOrderItem(o.data, o.viewItem);
		if (result.success) {
			this.selectOffer(result.basketOffer, o);
		}
	}

	async selectOffer(_offer, o) {
		if (_offer._disabled) {
			this.appService.alert({ content: this.appService.translate("ITEM_OUT_OF_STOCK_MESSAGE", { count: _offer.stock }) });
			return;
		}
		await this.orderService.validateOrderLimit(1, _offer.price);
		this.orderDialogs.openOfferDialog(_offer, false, this.$storage.basket).then((result: any) => {
			if (result) {
				this.orderService.addToBasket(result.viewItem);
				this.chatService.updateBasket();
			}
		})
	}

	cancel() {
		this._bottomSheetRef.dismiss();
	}

}
